import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const LikeliHoodAverageRecord = Record({
  badges: [false, false, false, false, false, false, false, false],
  description: '',
  value: 0,
});

export default class LikeliHoodAverage extends LikeliHoodAverageRecord {
  static deserialize(jsonObject = {}) {
    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject), {});

    return new LikeliHoodAverage(hydrated);
  }
}
